import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

/**
 * Table row/column icons vendored from @fortawesome/pro-regular-svg-icons@7.3.0
 * (covered by the project's FontAwesome Pro licence — see .npmrc).
 * These don't exist in the installed v6 packages; drop this file and import them
 * normally if/when the app upgrades to Font Awesome 7.
 */

export const farTableColumnsAddAfter: IconDefinition = {
  prefix: 'far',
  iconName: 'table-columns-add-after' as any,
  icon: [
    576,
    512,
    [],
    'e88e',
    'M448 32c35.3 0 64 28.7 64 64l-48 0c0-8.8-7.2-16-16-16l-136 0 0 352 136 0c8.8 0 16-7.2 16-16l48 0c0 33.1-25.2 60.4-57.5 63.7l-6.5 .3-320 0-6.5-.3c-30.1-3.1-54.1-27-57.1-57.1L64 416 64 96c0-35.3 28.7-64 64-64l320 0zM128 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l136 0 0-352-136 0zm352 80c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24z',
  ],
}

export const farTableColumnsRemoveAfter: IconDefinition = {
  prefix: 'far',
  iconName: 'table-columns-remove-after' as any,
  icon: [
    576,
    512,
    [],
    'e892',
    'M448.4 32c35.3 0 64 28.7 64 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16l-136 0 0 352 136 0c8.8 0 16-7.2 16-16l0-32 48 0 0 32c0 33.1-25.2 60.4-57.5 63.7l-6.5 .3-320 0-6.5-.3c-30.1-3.1-54.1-27-57.1-57.1l-.3-6.5 0-320c0-35.3 28.7-64 64-64l320 0zm-320 48c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l136 0 0-352-136 0zM514.4 188.1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-33.9 33.9 34 34c9.4 9.4 9.4 24.6 0 33.9-9.4 9.4-24.6 9.4-34 0l-33.9-33.9-33.9 33.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l33.9-33.9-33.9-33.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l33.9 33.9 33.9-33.9z',
  ],
}

export const farTableRowsAddBelow: IconDefinition = {
  prefix: 'far',
  iconName: 'table-rows-add-below' as any,
  icon: [
    448,
    512,
    [],
    'e895',
    'M0 416c0 35.3 28.7 64 64 64l0-48c-8.8 0-16-7.2-16-16l0-136 352 0 0 136c0 8.8-7.2 16-16 16l0 48c33.1 0 60.4-25.2 63.7-57.5l.3-6.5 0-320-.3-6.5c-3.1-30.1-27-54.1-57.1-57.1L384 32 64 32C28.7 32 0 60.7 0 96L0 416zM48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 136-352 0 0-136zm80 352c0 13.3 10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24z',
  ],
}

export const farTableRowsRemoveBelow: IconDefinition = {
  prefix: 'far',
  iconName: 'table-rows-remove-below' as any,
  icon: [
    448,
    512,
    [],
    'e899',
    'M0 416c0 35.3 28.7 64 64 64l32 0 0-48-32 0c-8.8 0-16-7.2-16-16l0-136 352 0 0 136c0 8.8-7.2 16-16 16l-32 0 0 48 32 0c33.1 0 60.4-25.2 63.7-57.5l.3-6.5 0-320-.3-6.5c-3.1-30.1-27-54.1-57.1-57.1L384 32 64 32C28.7 32 0 60.7 0 96L0 416zM48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 136-352 0 0-136zM156.1 481.9c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l33.9-33.9 34 34c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.4-24.6 0-34l-33.9-33.9 33.9-33.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-33.9 33.9-33.9-33.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L190 448 156.1 481.9z',
  ],
}
